<template>
	<v-dialog v-model="localDialog" ref="leaveDialogRef" max-width="70%">
		<v-sheet>
			<v-card class="d-flex flex-column rounded-lg" v-if="!loading && !dialogSubmit">
				<v-card-title>
					<div>
						<span class="headline pr-4 font-weight-bold">Leave Request</span>
						<v-btn
							small
							text
							class="mx-4 rounded-lg purple lighten-5 text-capitalize"
							@click="showDays"
							:disabled="Boolean(leaveId)"
						>
							<img left src="@/assets/Leaves/daily-calendar.svg" width="14px">
							<span class="black--text px-1 caption font-weight-bold">Many Days</span>
						</v-btn>
						<v-btn
							small
							text
							class="mx-2 rounded-lg blue lighten-5 text-capitalize"
							@click="showHours"
							:disabled="Boolean(leaveId)"
						>
							<img left src="@/assets/Leaves/calendar-clock.svg" width="14px">
							<span class="black--text px-1 caption font-weight-bold">Hourly</span>
						</v-btn>
					</div>
					<v-spacer></v-spacer>
					<div class="d-flex">
						<!-- <v-card outlined :class="getClass" class="mx-2 px-4 header-left-background">
							<div class="text-caption py-1">16589</div>
						</v-card> -->
						<v-card outlined :class="getClass" class="mx-2 px-4 header-left-background rounded-lg">
							<div class="text-caption py-1">{{ currentTime }}</div>
						</v-card>
						<v-card outlined :class="getClass" class="mx-2 px-4 header-left-background rounded-lg">
							<div class="text-caption py-1">{{ currentDate }}</div>
						</v-card>
					</div>

				</v-card-title>
				<v-card-text> 
					<div>
						<v-row class="d-flex align-center">
							<v-col cols="8" v-if="formData.isDaily">
								<!-- daily -->
								<v-row class="ma-0">
									<v-col cols="2" class="py-0 px-1">
										<v-text-field 
											v-model.number="formData.durationInDays" 
											:error="formData.durationInDays < 0" 
											:error-messages="formData.durationInDays < 0 ? ['Invalid duration'] : []" 
											hide-details="auto"
											dense 
											label="Duration (days)"  
											type="number" 
											:min="0" 
											:disabled="isOnlyShow"
											class="input rounded-lg"
											solo
											:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
										></v-text-field>
									</v-col>
									<span class="my-3 ps-2">from:</span>
									<v-col cols="4" class="py-0 px-1">
										<bee-date-picker
											v-model="formData.fromDate" 
											:input-label="formattedLabel"
											elevation="2"
											menu-picker
											hide-details
											:min-date="today"
											days-over-max="18"
											:input-props="{
												dense: true,
												clearable: false,
												outlined: true
											}"
											:disabled="isOnlyShow"
										></bee-date-picker>
									</v-col>
									<span class="my-3 ps-2">to: </span>
									<v-col cols="4" class="py-0 px-1">
										<v-text-field
											v-model="formData.toDate" 
											readonly
											hide-details
											:disabled="isOnlyShow"		
											dense
											clearable
											label="To"
											class="input rounded-lg"
											solo
											:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
										/>
									</v-col>
								</v-row>
							</v-col>
							<!-- hourly -->
							<v-col cols="auto" v-if="!formData.isDaily" class="pt-0 pb-1">
								<!-- hourly -->
								<v-row class="ma-0">
									<v-col cols="2" class="px-1"> 
										<v-text-field 
											v-model.number="formData.durationInMinute" 
											dense 
											label="Duration (hours)"  
											type="number" 
											:step="0.5"
											:min="0"
											@input="calculateToTime" 
											:error="!isValidDuration && formData.durationInMinute !== ''" 
											:error-messages="!isValidDuration && formData.durationInMinute !== '' ? ['Invalid duration'] : []"
											hide-details="auto"
											:disabled="isOnlyShow"
											solo
											:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
											class="input rounded-lg"
										>
											<template v-slot:append>
												<span> H </span>
											</template>
										</v-text-field> 
									</v-col>
									<v-divider vertical class="my-3 mx-1" />
									<v-col cols="3" class="px-1">
										<bee-date-picker
											v-model="dateHourly"
											input-label="Date"
											input-format-order="DD-MM-YYYY"
											dense
											hide-details="auto"
											menu-picker
											days-over-max="18"
											:min-date="today"
											:input-props="{
												readonly: true,
												outlined: true,
												filled: false,
												dense: true,
												clearable: true,
												prependIcon: 'mdi-calendar-plus',
												backgroundColor: 'grey lighten-5'
											}"
										></bee-date-picker>
									</v-col>
									<v-divider vertical class="my-3 mx-1" />
									<v-col cols="3" class="d-flex justify-center align-center px-1" align-self="center">
										<span class="me-1"> from: </span> 
										<v-text-field 
											v-model="fromTime" 
											@input="calculateToTime"
											dense 
											label="Start Time" 
											solo
											:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''" 
											class="input rounded-lg"
											type="time"
											:error="fromTime !== '' && isBeforeNineAM(fromTime)" :error-messages="fromTime !== '' && isBeforeNineAM(fromTime) ? ['Time is before 9:00 AM'] : []"
											hide-details="auto"
											:disabled="isOnlyShow"
										></v-text-field>
									</v-col>
									
									<v-col cols="3" class="d-flex justify-center align-center px-1" align-self="center">
										<span class="me-1"> to: </span>
										<v-text-field 
											v-model="toTime" 
											dense 
											label="End Time" 
											solo
											:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''" 
											type="time" 
											class="input rounded-lg"
											readonly
											:error="toTime !== '' && isAfterFivePM(toTime)" 
											:error-messages="toTime !== '' && isAfterFivePM(toTime) ? ['Time is after 5:00 PM'] : []"
											hide-details="auto"
											disabled
										></v-text-field>
									</v-col>
								</v-row>
							</v-col>
							<v-spacer></v-spacer>
							<v-col cols="auto" class="pt-0">
								<v-radio-group row v-model="formData.leaveTypeId" hide-details class="mt-0">
									<v-radio
										v-for="(type, index) in leaveTypes"
										:key="index"
										:label="type.name"
										:value="type.id"
										:disabled="isOnlyShow"
									></v-radio>
								</v-radio-group>
							</v-col>
						</v-row>
						<div>
							<v-form>
								<v-textarea
									label="Reason"
									rows="1"
									solo
									:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
									class="input rounded-lg"
									v-model="formData.reason"
									dense
									hide-details="auto"
									:disabled="isOnlyShow"
								></v-textarea>
							</v-form>
						</div>
						<div>
							<v-radio-group hide-details="auto" dense v-model="selectedRadio" row class="pa-0">
								<v-radio
									label="it won't affect the plan"
									value="will-not"
									:disabled="isOnlyShow">
								</v-radio>
								<v-radio
									label="it will affect the plan"
									value="will"
									:disabled="isOnlyShow">
								</v-radio>
							</v-radio-group>
						</div>
						<!-- <v-autocomplete
							v-if="selectedRadio === 'will'" 
							v-model="formData.plannedTasksId"
							:items="[]"
							item-text="name"
							item-value="id"
							label="Details about the plan" 
							outlined 
							rows="2"
							dense
							class="mt-2"
							hide-details
							:disabled="isOnlyShow"
						/> -->
						<div class="d-flex justify-content-center align-end mt-3 mb-2">
							<!-- <v-col cols="9">
								<h3 class="mb-4"> Supervisor Opinion: </h3>
								<v-textarea
								label="Opinion" 
								outlined 
								rows="1"
								v-model="formData.supervisorComment"
								dense
								class="mt-2"
								hide-details
								:disabled="isOnlyShow"
								></v-textarea>
							</v-col> -->
							<!-- <v-col cols="3">
								<div class="d-flex">
									<v-btn-toggle v-model="formData.supervisorAcceptance">
										<v-btn
											class="mb-1"
											:class="{'green-color white--text': formData.supervisorAcceptance === true}"
											:value="true"
											small
											:disabled="isOnlyShow"
										>
											Approve
										</v-btn>
										<v-spacer></v-spacer>
										<v-btn
											class="mb-1"
											:class="{'red-dark white--text': formData.supervisorAcceptance === false}"
											:value="false"
											small
											:disabled="isOnlyShow"
										>
											Reject
										</v-btn>
									</v-btn-toggle>
								</div>
							</v-col> -->
						</div>
						<div :class="['px-4', 'pb-4', 'pt-0', backgroundClass, 'rounded']">
							<h4 class="mb-3">
								<img lefr src="@/assets/Leaves/terms-check 2.svg" width="15px" class="pr-1">
								<span>Terms</span>
							</h4>
							<ul dir="rtl">
								<li class="zain-bold"> إجازات براتب: يوم واحد شهرياً، وتراكم ساعات الإجازات الساعية بواقع 8 ساعات للإداريين و7 ساعات للمطورين ليوم واحد، مع حد أقصى 2 إجازات براتب شهرياً واحتساب تعويض مالي إذا لم تُستَخدم نهاية العام.</li>
								<li class="zain-bold"> إجازات بدون راتب:  15 يوم سنوياً، وتفضيل الإجازات براتب قبل بدون راتب مع خصم مالي يعادل مدة الإجازة من الراتب.</li>
								<li class="zain-bold"> طلب الإجازة قبل يوم عمل كامل للإجازة اليومية، وبداية الدوام للإجازة الساعية.</li>
								<li class="zain-bold"> الحالات الطارئة تسمح بطلب عبر زميل من القسم وتُطبَّق نفس الشروط.</li>
								<li class="zain-bold"> التمديد غير مقبول ويجب إلغاء الطلب في حال إلغاء الإجازة. </li>
							</ul>
						</div>
					</div>
				</v-card-text> 
				<v-card-actions> 
					<v-spacer></v-spacer>
					<v-btn
						class="text-none white--text rounded-lg"
						color="orange text-capitalize"
						@click="submit"
						:disabled="isOnlyShow || !leaveTypes.length || !formData.leaveTypeId"
					>
						Submit
					</v-btn>
					<v-btn
						color="alert-color white--text"
						class="text-none rounded-lg"
						@click="closeDialogs"
					>
						Cancel
					</v-btn>
				</v-card-actions>
			</v-card>
			<div v-else-if="loading" class="d-flex justify-center align-center" style="height: 400px;">
				<v-progress-circular indeterminate color="orange text-capitalize"></v-progress-circular>
				<span class="ml-3">Loading...</span>
			</div>

			<div v-else-if="dialogSubmit">
				<v-card-title
					class="headline d-flex justify-center align-center"
					style="height: 300px;"
				>
					Your request is done
				</v-card-title>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="orange text-capitalize" @click="closeDialogs">
						Close
					</v-btn>
				</v-card-actions>
			</div>
		</v-sheet>
	</v-dialog>
</template>
<script>
import moment from 'moment';
import { mapState } from 'vuex';
export default {
	name: 'LeavesDialog',
	props: {
		dialog: {
			type: Boolean, 
			required: true 
		},
		leaveData: { 
			type: Object, default: () => ({})
		},
		leaveId: {
			type: String
		},
		isOnlyShow: {
			type: Boolean
		}
	},
	data () {
		return {
			formData: this.LeaveData || {
				fromDate: null, 
				toDate: null, 
				isDaily: true, 
				durationInDays: 0, 
				durationInMinute: 0, 
				reason: null, 
				leaveTypeId: null, 
				status: 0, 
				supervisorAcceptance: null, 
				supervisorComment: null, 
				managerAcceptance: null, 
				termsAccept: false, 
				compensable: false, 
				leaveTaskIds: [],
				plannedTasksId: []
			}, 
			fromTime: null, 
			toTime: null, 
			dateHourly: moment().format('YYYY-MM-DD'),
			selectedRadio: 'will-not',
			currentTime: null, 
			currentDate: null,
			loading: false,
			dialogSubmit: false,
			defaultLabel: 'From',
			defaultToLabel: 'To',
			leaveTypes: []
		}
	},	
	mounted () {
		this.updateTime(); 
		this.updateDate(); 
		this.getLeavesType();
		setInterval(this.updateTime, 1000); 
	},
	methods: { 
		getSelfLeaves () {
			this.$store.dispatch('leaves/fetchLeavesByUserId', { userId: this.self.id, year: moment().year() }).then((data) => {
				this.leavesByUser = data
			}).finally(() => {
				this.loading = false
			})
		},

		fetchRemaining () {
			this.$store.dispatch('leaves/fetchRemaining', { userId: this.self.id }).then((data) => {
				this.leavesRemaining = data
			})
		},
		getLeavesType () {
			this.$store.dispatch('leaves/fetchLeavesTypeForEmployee', { id: this.self.employeeId }).then((data) => {
				this.leaveTypes = data
			})
			// this.$store.dispatch('leaves/fetchLeavesType').then((data) => {
			// 	this.leaveTypes = data
			// 	console.log(this.leaveTypes)
			// })
		}, 
		updateTime () {
			const now = new Date(); 
			this.currentTime = now.toLocaleTimeString(); // Format time as HH:MM:SS 
		}, 
		updateDate () {
			const now = new Date(); 
			this.currentDate = moment(now).format('DD/MM/YYYY');
		},
		showDays () { 
			this.formData.isDaily = true
		},
		showHours () { 
			this.formData.isDaily = false
		},
		calculateToTime () { 
			if (this.fromTime && this.formData.durationInMinute) { 
				const fromTime = moment(this.fromTime, 'HH:mm'); 
				const toTime = fromTime.add(this.formData.durationInMinute, 'hours'); 
				this.toTime = toTime.format('HH:mm');
			} 
		},
		// calculateToTime () { 
		// 	if (this.formData.fromDate && this.formData.durationInMinute) { 
		// 		const fromTime = moment(this.formData.fromDate, 'HH:mm'); 
		// 		const toTime = fromTime.clone().add(this.formData.durationInMinute, 'hours'); 
		// 		this.formData.toDate = toTime.format('HH:mm');
		// 	} 
		// },

		isValidTime (time) { 
			return moment(time, 'HH:mm', true).isValid(); 
		}, 
		isBeforeNineAM (time) { 
			if (!time) return false; 
			const timeMoment = moment(time, 'HH:mm'); 
			const nineAM = moment('09:00', 'HH:mm'); 
			return timeMoment.isBefore(nineAM); 
		}, 
		isAfterFivePM (time) { 
			if (!time) return false; 
			const timeMoment = moment(time, 'HH:mm'); 
			const fivePM = moment('17:00', 'HH:mm'); 
			return timeMoment.isAfter(fivePM); 
		},
		
		// submitLeaveRequest () { 
		// 	const formattedFromTime = moment(this.fromTime, 'HH:mm').format('hh:mm A'); 
		// 	const formattedToTime = moment(this.toTime, 'HH:mm').format('hh:mm A');
		// 	const formattedFromDate = moment(this.fromDate, 'YYYY-MM-DD').format('D MMM YYYY'); 
		// 	const formattedToDate = moment(this.toDate, 'YYYY-MM-DD').format('D MMM YYYY');
		// 	const leaveDetails = { 
		// 		id: this.cards.length + 1, 
		// 		type: this.isDaysVisible ? 'Daily' : 'Hourly', 
		// 		from: this.isDaysVisible ? formattedFromDate : formattedFromTime, 
		// 		to: this.isDaysVisible ? formattedToDate : formattedToTime, 
		// 		days: this.isDaysVisible ? `${this.duration} Days` : '-', 
		// 		hours: this.isHoursVisible ? `${this.durationHours} Hours` : '-', 
		// 		reason: this.reason || '-',
		// 		status: 'Pinned' 
		// 	}; 
		// 	this.cards.push(leaveDetails); this.dialog = false; 
		// }

		// handleSubmit () {
		// 	this.loading = true;
		// 	setTimeout(() => {
		// 		this.loading = false;
		// 		this.dialogSubmit = true;
		// 	}, 2000)
		// },

		closeDialogs () { 
			this.$emit('update:dialog', false);
			// this.dialog = false; 
			this.dialogSubmit = false;
		},
		submit () {
			this.loading = true
			const submitData = { 
				id: this.leaveId,
				fromDate: this.formData.isDaily === true ? this.formData.fromDate : (moment(this.dateHourly).format('YYYY-MM-DD') + 'T' + this.fromTime),
				toDate: this.formData.isDaily === true ? this.formData.toDate : (moment(this.dateHourly).format('YYYY-MM-DD') + 'T' + this.toTime),
				isDaily: this.formData.isDaily,
				durationInDays: this.formData.durationInDays,
				durationInMinute: this.formData.durationInMinute * 60,
				reason: this.formData.reason,
				status: this.formData.status,
				supervisorAcceptance: this.formData.supervisorAcceptance,
				supervisorComment: this.formData.supervisorComment,
				managerAcceptance: this.formData.managerAcceptance,
				termsAccept: this.formData.termsAccept,
				compensable: this.formData.compensable,
				leaveTaskIds: this.formData.leaveTaskIds,
				plannedTasksId: this.formData.plannedTasksId,
				leaveTypeId: this.formData.leaveTypeId
			};
			this.$emit('submit', submitData);
		},

		resetLoading () {
			this.loading = false
		}
	
	},
	computed: {
		...mapState({
			self: state => state.auth.self
		}),
		backgroundClass () {
			return this.$vuetify.theme.dark ? 'black--bg' : 'grey lighten-5'; 
		},
		isValidDuration () { 
			return this.formData.durationInMinute <= 6 && this.formData.durationInMinute >= 0; 
		},
		getClass () { 
			return this.$vuetify.theme.dark ? 'header-left-background-dark' : 'header-left-background'; 
		},
		dateArray () {
			if (!this.formData.fromDate || this.formData.durationInDays <= 0) return []; 
			const fromDate = moment(this.formData.fromDate, 'YYYY-MM-DD'); 
			const dates = []; 
			let daysToAdd = this.formData.durationInDays
			for (let i = 0; i < daysToAdd; i++) { 
				const currentDate = fromDate.clone().add(i, 'days'); 
				dates.push(currentDate); 
				if (currentDate.day() === 5) {
					daysToAdd++;
				}
			} 
			return dates; 
		},
		formattedLabel () { 
			return this.formData.fromDate ? moment(this.formData.fromDate).format('dddd') : this.defaultLabel; 
		},
		formattedToDateLabel () { 
			return this.formData.toDate ? moment(this.formData.toDate).format('dddd') : this.defaultToLabel; 
		},
		today () {
			return moment().format('YYYY-MM-DD');
		},
		localDialog: {
			get () {
				return this.dialog; // Access the prop
			},
			set (value) {
				this.$emit('update:dialog', value); // Emit event to update the parent
			}
		}
	},
	watch: { 
		dateArray (newVal) { 
			if (newVal.length > 0) { 
				const toDate = newVal[newVal.length - 1].clone(); 
				this.formData.toDate = toDate.format('YYYY-MM-DD'); // Set the end date as a date string 
			} else {
				this.formData.toDate = '';
			} 
		},
		leaveData (newVal) { 
			this.formData = { ...newVal }; 
		},

		localDialog (val) {
			if (!val) {
				this.formData.fromDate = null
				this.formData.toDate = null
				this.formData.isDaily = true
				this.formData.durationInDays = 0
				this.formData.durationInMinute = 0
				this.formData.reason = null
				this.formData.leaveTypeId = null	
				this.formData.status = 0
				this.formData.supervisorAcceptance = null
				this.formData.supervisorComment = null
				this.formData.managerAcceptance = null
				this.formData.termsAccept = false
				this.formData.compensable = false
				this.formData.leaveTaskIds = []
				this.formData.plannedTasksId = []
				this.loading = false
			} 
			if (this.leaveId !== null && this.leaveId !== undefined) {
				this.loading = true
				this.$store.dispatch('leaves/fetchById', { id: this.leaveId }).then(({ data }) => {
					if (data.isDaily) {
						this.showDays()
					} else {
						this.showHours()
					}
					this.formData.fromDate = moment(data.fromDate).format('YYYY-MM-DD')
					this.formData.toDate = moment(data.toDate).format('YYYY-MM-DD')
					this.formData.isDaily = data.isDaily
					this.formData.durationInDays = data.durationInDays
					this.formData.durationInMinute = (data.durationInMinute) / 60
					this.formData.reason = data.reason
					this.formData.leaveTypeId = data.leaveTypeId	
					this.formData.status = data.status
					this.formData.supervisorAcceptance = data.supervisorAcceptance
					this.formData.supervisorComment = data.supervisorComment
					this.formData.managerAcceptance = data.managerAcceptance
					this.formData.termsAccept = data.termsAccept
					this.formData.compensable = data.compensable
					this.formData.leaveTaskIds = data.leaveTaskIds
					this.formData.plannedTasksId = data.plannedTasksId
					this.fromTime = (data.fromDate).split('T')[1]
					this.toTime = (data.toDate).split('T')[1]
				}).finally(() => {
					this.loading = false
				})
			}
		}
	}
}
</script>
<style scoped>
</style>
